import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchTeacherReports = (args, config) => {
    return useQuery({
        queryKey: ['teacher', 'report', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/teacher/reports`, {params: config})
        })(args)),
    })
}

export function useApiCreateTeacherReports() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/teacher/reports`, data)
            })(data))
    });
}


export function useApiCreateTeacherReportsModerator() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/teacher/reports-moderator`, data)
            })(data))
    });
}


export const useApiReadTeacherReportsModerator = (args, config) => {
    return useQuery({
        queryKey: ['teacher', 'report', 'moderator', 'get', args?.lesson_id, args?.date],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/teacher/reports-moderator`, {params: config})
        })(args)),
    })
}

export const useApiSearchTeacherReportsTypes = (args, config) => {
    return useQuery({
        queryKey: ['teacher', 'report', 'type', 'search'],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/teacher/reports/types`, {params: config})
        })(args)),
    })
}
